import { Component, Input  } from '@angular/core';
import { LabelMaps, ShareOSSInfo } from 'src/app/store/events.era';
import { Performer } from 'globals/store/performers.data';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { Ranking, Venue } from 'globals/store/events.data';
import { TagPanelData } from 'globals/store/tags.data';
import { BrandingData } from 'globals/store/publish.data';
import { Dictionary } from '@ngrx/entity';
import { OnsiteSingleTimelineComponent } from './onsite.singletimeline.component';
import { AddToCalComponent } from 'src/app/components/misc/add-to-cal.component';
import { str2Date } from 'globals/helpers/helpers';
import { Str2DatePipe } from 'src/app/services/pipes/Str2Date.pipe';
import { SharedTimelineComponent } from 'src/app/components/wrappers/shared-timeline-wrapper.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-timeline',
    template: `
<branding-wrapper [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <shared-timeline-wrapper *ngIf="ossShareInfo"
    [eventTitle]="ossShareInfo.eventTitle"
    [title]="ossShareInfo.title"
    [shareCode]="shareId"
    [eventId]="eventId"
    [description]="ossShareInfo.description"
    [madeWithJoi]="madeWithJoi"
    [loading]="loading"
    [unavailable]="unavailable">
    <div class="single-timeline" *ngFor="let dayTimeline of timeline; trackBy: trackByDate">
      <h3 class="group_date" *ngIf="dayTimeline.date">
        <span *ngIf="!dayTimeline.dayDate">{{ dayTimeline.dateId | str2Date | date:"EEEE d LLLL y" }}</span>
        <span *ngIf="dayTimeline.dayDate">{{ dayTimeline.dayDate }}</span>
      </h3>
      <add-to-cal *ngIf="timeline.length && ossShareInfo.id " [title]="ossShareInfo.eventTitle" [eventId]="ossShareInfo.eventId" [shareCode]="ossShareInfo.id" entityType="oss" entityId="" ></add-to-cal><!-- Need to implement for exhibitor -->

      <single-timeline 
        [link]="false"
        [condensedPerformers]="false"
        [singleTimeline]="dayTimeline"
        [hidePerformersHeading]="true"
        [labelMaps]="labelMaps"
        [venues]="venues"
        [showActivityStatus]="showActivityStatus"
        [publicView]="publicView"
        [performers]="performers"
        [performerRoles]="performerRoles"
        [sponsors]="sponsors"
        [sponsorTypes]="sponsorTypes"
        [tagMap]="tagMap"
      ></single-timeline>
    </div>
  </shared-timeline-wrapper>
</branding-wrapper>
  `,
    styles: [`
h3.group_date { text-align: center; }
  `],
    standalone: true,
    imports: [OnsiteSingleTimelineComponent, AddToCalComponent, Str2DatePipe, SharedTimelineComponent, BrandingWrapperComponent, CommonModule],
})

export class OnsiteShareTimelineComponent {
  @Input() timeline: OnsiteSingleTimeline[]
  @Input() eventId: string
  @Input() shareId: string
  @Input() performers: { [pId: string]: Performer }
  @Input() sponsors: { [key: string]: Sponsor }
  @Input() sponsorTypes: { [tId:string]: Ranking }
  @Input() labelMaps: LabelMaps
  @Input() ossShareInfo: ShareOSSInfo
  @Input() showActivityStatus = false
  @Input() unavailable = false
  @Input() loading = false
  @Input() madeWithJoi = true
  @Input() venues: { [vId:string]: Venue }
  @Input() tagMap: { [vId:string]: TagPanelData } = {}
  @Input() publicView: boolean = false
  @Input() brandingData: BrandingData
  @Input() performerRoles: Dictionary<Ranking>

  getTypeOf(o) {
    return typeof o
  }

  trackByDate(index, item: OnsiteSingleTimeline) {
    return item.date.toString()
  }

}

